// React
import React from 'react';
import {
  Col,
  Row,
  Form,
  Card,
  Input,
  Label,
  CardBody,
  CardFooter,
} from 'reactstrap';

// Containers Injections
import {
  PageWrapper,
  SelectInput,
  convertEventSelectToTarget,
} from '../../containers/componentsInjection';

export const ProposalsForRenewalPage = ({
  history,
  sellers,
  createData,
  validation,
  categoryPlans,
  organizations,
  departmentOptions,
  resetDepartmentInput,
  proposalStatusOptions,
  cadastralStatusOptions,
}) => {
  return (
    <PageWrapper title="Propostas para Renovação">
      <Row>
        <Col xxl={12}>
          <Card>
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody>
                <Row>
                  <Col md={12}>
                    {/* <div className="mb-3">
                          <h5>Filtros</h5>
                        </div> */}
                  </Col>
                  {/* <CardBody className="p-4"> */}
                  <Col md={4} className="mb-3">
                    <div>
                      <Label for="saleAtInput" className="form-label">
                        Período
                      </Label>
                      <div className="d-flex justify-content-center align-items-center">
                        <Input
                          type="date"
                          id="periodStarts"
                          value={validation.values.periodStarts}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />
                        <span className="m-2">a</span>
                        <Input
                          type="date"
                          id="periodEnds"
                          value={validation.values.periodEnds}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="sellerInput" className="form-label">
                        Corretor
                      </Label>
                      <SelectInput
                        isClearable
                        inputId="sellerInput"
                        value={validation.values.sellerInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'sellerInput',
                              eventInput
                            )
                          );
                          if (!eventInput) {
                            validation.handleChange({
                              target: {
                                name: 'sellerInput',
                                value: {
                                  label: '',
                                  value: '',
                                },
                              },
                            });
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'sellerInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(sellers)}
                        placeholder="Todos"
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="categoryPlanInput" className="form-label">
                        Categoria de Plano
                      </Label>
                      <SelectInput
                        multiple={true}
                        className="form-control"
                        inputId="categoryPlanInput"
                        value={validation.values.categoryPlanInput}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'categoryPlanInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'categoryPlanInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(categoryPlans)}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="organizationInput">
                        Organização
                      </Label>
                      <SelectInput
                        isClearable
                        inputId="organizationInput"
                        value={validation.values.organizationInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          resetDepartmentInput();
                          if (!eventInput) {
                            validation.handleChange({
                              target: {
                                name: 'organizationInput',
                                value: {
                                  label: '',
                                  value: '',
                                },
                              },
                            });
                          } else {
                            validation.handleChange(
                              convertEventSelectToTarget(
                                'organizationInput',
                                eventInput
                              )
                            );
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'organizationInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(organizations)}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="departmentInput">
                        Lotação
                      </Label>
                      <SelectInput
                        isDisabled={!validation.values.organizationInput.value}
                        inputId="departmentInput"
                        value={validation.values.departmentInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'departmentInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'departmentInput',
                              eventInput
                            )
                          );
                        }}
                        options={departmentOptions}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="mb-3">
                      <Label
                        htmlFor="employeeSituationInput"
                        className="form-label"
                      >
                        Situação Cadastral
                      </Label>
                      <SelectInput
                        multiple
                        className="form-control"
                        inputId="employeeSituationInput"
                        value={validation.values.employeeSituationInput}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'employeeSituationInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'employeeSituationInput',
                              eventInput
                            )
                          );
                        }}
                        options={cadastralStatusOptions}
                        placeholder="Selecione a situação cadastral"
                      />
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="mb-3">
                      <Label
                        htmlFor="proposalSituationInput"
                        className="form-label"
                      >
                        Situação da Proposta
                      </Label>
                      <SelectInput
                        multiple
                        className="form-control"
                        inputId="proposalSituationInput"
                        value={validation.values.proposalSituationInput}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'proposalSituationInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'proposalSituationInput',
                              eventInput
                            )
                          );
                        }}
                        options={proposalStatusOptions}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>

              <CardFooter>
                <Col md={12}>
                  <div className="text-end d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link"
                      style={{
                        marginRight: '10px',
                      }}
                      onClick={() => {
                        history.push('/relatorios');
                      }}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Gerar Relatório
                    </button>
                  </div>
                </Col>
              </CardFooter>
            </Form>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
